/* eslint-disable no-unused-vars */

export enum MODAL_TYPES {
  MOBILE_QUALITY_LIST = "mobileQualityList",
  MOBILE_SPEED_RATE_LIST = "mobileSpeedRateList",
  VIDEO_PLAYER = "video_player",
  CONFIRM_CERTIFICATE = "confirm_certificate",
  PDF_VIEWER = "pdf_viewer",
  COURSE_COLLECTION = "course_collection",
  GALLERY_IMAGE = "gallery_image",
  CONFIRM_ADDRESS = "confirm_address",
  EXPLORE_FILTER = "explore_filter",
  EXPLORE_CATEGORY = "explore_category",
  EXPLORE_SORT_MODAL = "explore_sort_modal",
  CREATE_FOLDER = "create_folder",
  REMOVE__FOLDER = "remove_folder",
  FOLDER_LIST = "folder_list",
  EDIT_FOLDER = "edit_folder",
  DELETE_CONFIRMATION = "delete_confirmation",
  SUBMIT_EDITOR = "submit_editor",
  MODAL_MENU = "modal_menu",
  SUBMIT_QUESTION = "submit_question",
  REPORT_EXAM_QUESTION = "report_exam_question",
  EXIT_EXAM = "exit_exam",
  SHARE_CERTIFICATE = "share_certificate",
  MOBILE_PLAYER_VIDEO = "mobile_player_video",
  STAR_RATE_COURSE = "star_rate_course",
  ACCESS_COMMENTS_LIST = "access_comments_list",
  NEW_CHECKOUT_AUTH = "new_checkout_auth",
  WATCH_VIDEO_OFFER = "watch_video_offer_modal",
  NEW_LOGIN_ALERT = "new_login_alert",
  ADD_ABOUT_US_COMMENT = "add_about_us_comment",
  EXPLORE_INSTRUCTOR = "explore_instructor",
  LOGOUT_CONFIRMATION = "logout_confirmation",
  REMOVE_CONFIRMATION = "remove_confirmation",
  COURSE_WARRANTY_DETAILS = "course_warranty_details",
  CHANGE_AI_CHAT_NAME = "change_ai_chat_name",
  TRANSACTION_DETAILS = "transaction_details",
  SHOW_PICTURE = "show_picture",
  SHARE_LINKEDIN_LOADING = "share_linkedin_loading",
  SHARE_CERTIFICATE_PROFILE = "share_certificate_profile",
  COUPON_PRODUCT = "coupon_product",
  TERMS_AND_CONDS = "terms_and_conds",
  REMOVE_FOLDER_PRODUCT = "remove_folder_product",
  PROFILE_SORT_MODAL = "profile_sort_modal",
  PROFILE_TYPE_MODAL = "profile_type_modal",
  SHOW_MORE_COMMENT = "show_more_comment",
  FEEDBACK = "feedback",
  ORDER_SORT_MODAL = "order_sort_modal",
  GET_FACTOR = "get_factor",
  PROFILE_TYPE_CERTIFICATE_MODAL = "profile_type_certificate_modal",
  CERTIFICATE_PREVIEW = "certificate_preview",
  SUBJECT_MODAL = "subject_modal",
  PRIORITY_MODAL = "priority_modal",
  FILE_UPLOAD_MODAL = "file_upload_modal",
  CHANGE_PASSWORD = "change_password",
  PROFILE_GENDER = "profile_gender",
  SEARCH_RECOMMENDED_SUBJECT = "search_recommended_subject",
  QUALITY_ASSURANCE_PRODUCT = "quality_assurance_product",
  REMOVE_CART_PRODUCT = "remove_cart_product",
  LOADING_VIEW = "loading_view",
  REPORT_COURSE = "report_course",
  NOWRUZ_MODAL = "nowruz_modal",
  SUBSCRIPTION_DETAIL = "subscription_detail",
  SUBSCRIPTION_TERMS = "subscription_terms",
  SELECT_SUBSCRIPTION_PLAN = "select_subscription_plan",
}

export interface Modal {
  type: MODAL_TYPES;
  data: { data: any; config: ModalGeneralProps };
}

export interface ModalGeneralProps {
  header?: string;
  closeIcon?: (closeModal?: () => void) => React.ReactNode;
  hideCloseIcon?: boolean;
  modalClassName?: string;
  modalHeaderClassName?: string;
  modalContentClassName?: string;
  useMobileClassName?: boolean;
  draggableSheet?: boolean;
  scrollFree?: boolean;
  useDesktopClassNameInMpbile?: boolean;
}

export type ModalState = Modal[];

export interface ModalProps<D = any> {
  closeModal: (clearModals?: boolean) => void;
  data: D;
}

/** Modal payload; kept loose so `addModal` call sites stay typed without importing modal UI. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ModalData<T extends MODAL_TYPES> = any;

export type ModalList = {
  [key in MODAL_TYPES]: React.FC<ModalProps>;
};
